var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import theme from "../theme";
export var Radio = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: transparent;\n  border-radius: 4px;\n  padding: 4px;\n  display: flex;\n  box-sizing: border-box;\n"], ["\n  background: transparent;\n  border-radius: 4px;\n  padding: 4px;\n  display: flex;\n  box-sizing: border-box;\n"])));
export var RadioItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 3px 8px;\n  background: ", ";\n  color: ", ";\n  border-radius: 4px;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  padding: 3px 8px;\n  background: ",
    ";\n  color: ",
    ";\n  border-radius: 4px;\n  cursor: pointer;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (_a) {
    var active = _a.active, mode = _a.mode;
    return active ? theme[mode].primaryColor : "";
}, function (_a) {
    var mode = _a.mode, active = _a.active;
    return active ? "#fff" : mode == "dark" ? "#fff" : theme[mode].fontColor;
}, function (_a) {
    var mode = _a.mode;
    return theme[mode].primaryHoverColor;
});
var templateObject_1, templateObject_2;
